import { Box, Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  StatusChip,
  CustomButton,
} from '../../../common';
import { hasOrdersNotGenerated } from '../utils/generationControlUtils';
import { useState } from 'react';

const CHIPS_PER_ROW = 20;

const chunkOrders = (orders = []) => {
  const result = [];
  for (let i = 0; i < orders.length; i += CHIPS_PER_ROW) {
    result.push(orders.slice(i, i + CHIPS_PER_ROW));
  }
  return result;
};

const GenerationControlDataTable = ({ data, isLoading, LoadingComponent }) => {
  const [expandedRows, setExpandedRows] = useState(new Set());

  const toggleRow = (index) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  };

  return (
    <GeneralTableBox>
      <Table aria-label="generation control table">
        <TableHead>
          <TableRow>
            <HeadTableCell wmd="10%" wxs="15%">
              A Generar
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="15%">
              Generados
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="15%">
              Sin Generar
            </HeadTableCell>
            <HeadTableCell wmd="30%" wxs="35%">
              Órdenes Sin Generar
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="10%">
              Mes
            </HeadTableCell>
            <HeadTableCell wmd="10%" wxs="10%">
              Año
            </HeadTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <LoadingComponent />
          ) : data && data.length > 0 ? (
            data.map((row, index) => (
              <TableRow key={index}>
              <RowTableCell>{row.toGenerate}</RowTableCell>
              <RowTableCell>{row.generated}</RowTableCell>
              <RowTableCell>{row.notGenerated}</RowTableCell>
              <RowTableCell>
                {hasOrdersNotGenerated(row.ordersNotGenerated) ? (
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {chunkOrders(row.ordersNotGenerated).map((chunk, chunkIndex) => {
                      const isHidden = chunkIndex > 0 && !expandedRows.has(index);
                      if (isHidden) {
                        return null;
                      }

                      const chipsToRender =
                        chunk.length > CHIPS_PER_ROW && !expandedRows.has(index)
                          ? chunk.slice(0, CHIPS_PER_ROW)
                          : chunk;

                      return (
                        <Box
                          key={`chunk-${chunkIndex}`}
                          sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                            gap: 0.5,
                          }}
                        >
                          {chipsToRender.map((order, orderIndex) => (
                            <StatusChip
                              key={`${chunkIndex}-${orderIndex}`}
                              variant="filled"
                              status="warning"
                              label={order}
                            />
                          ))}
                        </Box>
                      );
                    })}

                    {row.ordersNotGenerated.length > CHIPS_PER_ROW && (
                      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                        <CustomButton
                          variant="outlined"
                          size="small"
                          onClick={() => toggleRow(index)}
                          sx={{
                            px: 2,
                            py: 0.5,
                            borderRadius: '20px',
                            fontWeight: 500,
                          }}
                        >
                          {expandedRows.has(index)
                            ? 'Ver menos'
                            : `Ver ${row.ordersNotGenerated.length - CHIPS_PER_ROW} más`}
                        </CustomButton>
                      </Box>
                    )}
                  </Box>
                ) : (
                  '-'
                )}
              </RowTableCell>
                <RowTableCell>{row.month}</RowTableCell>
                <RowTableCell>{row.year}</RowTableCell>
              </TableRow>
            ))
          ) : (
            <NoDataSkeleton
              colSpan={6}
              message="No se encontraron registros de control de generación"
            />
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default GenerationControlDataTable;
